module.exports = __webpack_public_path__ + "cd3814f59d42dd68e33ef3c12a061613.png";